import { ImpersonateUserForm } from "@components"
import PropTypes from "prop-types"

const ImpersonateUser = ({ backButton, event }) => (
  <div>
    <ImpersonateUserForm event={event} clientId={event.client_id} />

    {backButton}
  </div>
)

ImpersonateUser.propTypes = {
  backButton: PropTypes.element.isRequired,
  event: PropTypes.shape({
    id: PropTypes.string.isRequired,
    client_id: PropTypes.string.isRequired,
    open_staff: PropTypes.bool.isRequired,
  }).isRequired,
}

export default ImpersonateUser